import React from 'react';
import styles from './DemoSection.module.css';
import SnapTour from '../SnapTour';

/**
 * Product demonstration.
 *
 * Until real screenshots exist this is one honest placeholder whose caption
 * changes. A fabricated interface here would be a claim about the product.
 *
 * To drop assets in, set `src` on a screen. A screen with a `src` renders the
 * image; without one it keeps the labelled placeholder. No other change is needed.
 */
const SCREENS = [
  {
    id: 'card',
    label: 'Your digital card',
    caption: 'What opens on the other person\u2019s phone when you share.',
    src: null,
  },
  {
    id: 'contacts',
    label: 'Contacts',
    caption: 'Every person you have met, with current details rather than a snapshot.',
    src: null,
  },
  {
    id: 'map',
    label: 'Where you met',
    caption: 'The same contacts on a map, by event and by date.',
    src: null,
  },
  {
    id: 'dashboard',
    label: 'Team hub',
    caption: 'Activity by team and by person. The network the business owns.',
    src: null,
  },
];

const Placeholder = ({ label }) => (
  <div className={styles.placeholder} aria-hidden="true">
    <span className={styles.placeholderGrid} />
    <span className={styles.placeholderLabel}>{label}</span>
  </div>
);

const DemoSection = () => (
  <section className="vxm-section vxm-section--raised" id="demo">
    <div className="vxm-container">
      <div className="vxm-section-head vxm-reveal">
        <p className="vxm-eyebrow">See it</p>
        <h2 className="vxm-h2">What Velox actually looks like</h2>
        <p className="vxm-body">
          The card is the part people notice. These are the screens that do the
          work afterwards.
        </p>
      </div>

      <div className="vxm-reveal">
        <SnapTour
          slides={SCREENS}
          ariaLabel="Velox product tour"
          layout="single"
          renderSlide={(screen) => (
            <figure className={styles.slide}>
              <div
                className={`${styles.tileFrame} ${screen.src ? '' : styles.tileFramePending}`}
              >
                {screen.src ? (
                  <img
                    className={styles.media}
                    src={screen.src}
                    alt={screen.label}
                    loading="lazy"
                  />
                ) : (
                  <Placeholder label={screen.label} />
                )}
              </div>
              <figcaption>
                <p className={styles.tileLabel}>{screen.label}</p>
                <p className={styles.tileCaption}>{screen.caption}</p>
                {!screen.src && (
                  <p className={styles.walkthroughNote}>Walkthrough coming shortly</p>
                )}
              </figcaption>
            </figure>
          )}
        />
      </div>
    </div>
  </section>
);

export default DemoSection;
